export default "__VITE_ASSET__BkUlxFyE__"